import _Textarea from './Textarea'
import _TextareaConnected from './Textarea.container'

export const Textarea = _Textarea
export const TextareaConnected = _TextareaConnected



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Input/Textarea/index.js